import { Injectable } from '@angular/core';
import { Basket, IBasketData } from '@df/session/api/basket/basket';
import flatten from 'lodash-es/flatten';
import uniq from 'lodash-es/uniq';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketItem {
            product_type?: 'configurable' | 'simple';
            children?: IBasketItemDataChild[];
            isVirtual?: boolean;
        }
    }
}

interface IBasketItemDataChild {
    product: number;
    product_type: 'configurable' | 'simple';
    id?: number;
}

@Injectable({
    providedIn: 'root'
})
export class BasketDecorator extends Basket {
    override getProductIdsToLoad(data: IBasketData = this.data): number[] {
        const ids = super.getProductIdsToLoad(data);

        const children = flatten(data?.items?.map(item => item.children?.map(child => child.product)) || []).filter(i => !!i) as number[];
        return uniq([...ids, ...children]);
    }
}
